import React from 'react'
import { InfoTooltip } from './InfoTooltip'

export const PermissionsInfoGroup: React.FC = () => {
  return (
    <div className="flex items-center gap-2 ml-2">
      <InfoTooltip 
        title="Berechtigungssystem"
        imagePath="/images/Berechtigungen.png"
        position="bottom"
      />
      <InfoTooltip 
        title="Rollen-Hierarchie"
        imagePath="/images/Rollen_Hierarchie.png"
        position="bottom"
      />
      <InfoTooltip 
        title="Löschszenarien"
        imagePath="/images/loeschszenarien.png"
        position="bottom"
      />
    </div>
  )
} 